import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { errMsg } from "@/lib/api";
import { portalApi } from "@/lib/portalApi";
import { usePortalAuth } from "@/context/PortalAuthContext";
import { PortalAuthCard } from "./PortalLogin";

export default function PortalSetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { setPassword } = usePortalAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [f, setF] = useState({ p1: "", p2: "" });
  useEffect(() => { portalApi.get("/auth/invite", { params: { token } }).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e))); }, [token]);
  const submit = async (e) => {
    e.preventDefault();
    if (f.p1 !== f.p2) return setError("Passwords do not match");
    try { await setPassword(token, f.p1); navigate("/portal"); } catch (err) { setError(errMsg(err)); }
  };
  return (
    <PortalAuthCard title="Set your password" subtitle={info ? `${info.tenant.name} client portal · ${info.email}` : "Client portal"} brand={info?.tenant.brand_color}>
      {info ? (
        <form onSubmit={submit} className="space-y-4" data-testid="set-password-form">
          <PasswordInput data-testid="set-password-input" placeholder="New password (min 8 characters)" minLength={8} value={f.p1} onChange={(e) => setF({ ...f, p1: e.target.value })} required />
          <PasswordInput data-testid="set-password-confirm" placeholder="Confirm password" value={f.p2} onChange={(e) => setF({ ...f, p2: e.target.value })} required />
          {error && <p data-testid="set-password-error" className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700">{error}</p>}
          <Button data-testid="set-password-submit" type="submit" className="w-full bg-[#13294B] hover:bg-[#1c3a66]">Save and sign in</Button>
        </form>
      ) : <p data-testid="set-password-error" className="text-sm text-rose-700">{error || "Checking your link…"}</p>}
    </PortalAuthCard>
  );
}
